// src/customHooks/useWebsiteSharedUid.ts

/*
    This custom hook returns the website_shared_uid for a specific site name.
*/

import { useSelector } from "react-redux";

export const useWebsiteSharedUid = (
  siteName: string = "bestbookiesandbettingsites",
): string | null => {
  const { userData } = useSelector((state: any) => state.user);
  const websitePermissions = userData?.data?.website_permissions || [];

  for (const permission of websitePermissions) {
    const [id, details] = Object.entries(permission)[0];
    //@ts-ignore
    if (details.site_name === siteName) {
      return id;
    }
  }

  // Fallback to first site's ID
  if (websitePermissions.length > 0) {
    return Object.keys(websitePermissions[0])?.[0];
  }

  return null;
};
